"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 10: MMC4
 * ------------------------------------------------------------------ */
// MMC4

// Seuil du filtre RC qui precede le compteur d'IRQ, comme sur le MMC3 et le
// MMC2 : huit dots au niveau bas suffisent a faire passer le front normal de la
// fenetre des sprites, qui en compte 256.
var A12_FILTER_DOTS = 8;

function register(Mappers) {
  Mappers[10] = function (nes) {
    this.nes = nes;
  };

  Mappers[10].prototype = new Mappers[0]();

  /*
   * MMC4's IRQ counter is clocked by PPU A12 rises, the same filter the MMC3
   * uses, so it belongs to the "a12" path rather than the once-per-scanline one.
   * Leaving it on "scanline" meant a latch of 8 fired after eight lines instead
   * of the roughly a third of a line that eight A12 edges actually span, and an
   * MMC4 game's status-bar split landed a long way from where it asked for it.
   */
  Mappers[10].prototype.irqClockRate = "a12";
  Mappers[10].prototype.watchesA12 = true;

  Mappers[10].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);

    this.chrBank0 = 0;
    this.chrBank1 = 0;
    this.prgBank0 = 0;
    this.prgBank1 = 0;
    this.prgMode = 1;
    this.chrMode = 1;

    this.irqLatch = 0;
    this.irqCounter = 0;
    this.irqReload = false;
    this.irqEnabled = false;
    // Last level of A12, so notifyA12 can spot the next rising edge.
    this.lastA12 = false;
  };

  Mappers[10].prototype.notifyA12 = function (level, lowDots) {
    // Front montant d'A12 qui a franchi le filtre : c'est ce qui horodate le
    // compteur du MMC4 comme celui du MMC3.
    this.lastA12 = level === 1;

    if (level === 1 && lowDots >= A12_FILTER_DOTS) {
      this.clockIrqCounter();
    }
  };

  Mappers[10].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    switch (address) {
      case 0x8000:
        // Mirroring (bit 0), PRG mode (bit 1), CHR mode (bit 2).
        this.setMirroring(
          (value & 1) !== 0
            ? this.nes.rom.HORIZONTAL_MIRRORING
            : this.nes.rom.VERTICAL_MIRRORING,
        );
        this.prgMode = (value >> 1) & 1;
        this.chrMode = (value >> 2) & 1;
        this.updateChrBanks();
        this.updatePrgBanks();
        break;

      case 0x8001:
        this.chrBank0 = value & 0x0f;
        this.updateChrBanks();
        break;

      case 0x8002:
        this.chrBank1 = value & 0x0f;
        this.updateChrBanks();
        break;

      case 0xa000:
        this.prgBank0 = value & 0x0f;
        this.updatePrgBanks();
        break;

      case 0xa001:
        this.prgBank1 = value & 0x0f;
        this.updatePrgBanks();
        break;

      case 0xb000:
        this.irqLatch = value;
        break;

      case 0xb001:
        this.irqReload = true;
        break;

      case 0xe000:
        this.irqEnabled = false;
        break;

      case 0xe001:
        // Unconditional, like MMC3's $E001 and unlike what this used to do.
        // Gating the enable on "no reload is pending" inverted the board's own
        // documented arming sequence: a game writes $B000 latch, $B001 reload,
        // $E001 enable, and with the reload still pending the enable turned the
        // counter off instead of on. It also meant a game that enabled the IRQ
        // before ever reloading could never arm it at all.
        this.irqEnabled = true;
        break;

      default:
        break;
    }
  };

  Mappers[10].prototype.updateChrBanks = function () {
    if (this.chrMode === 0) {
      // 8 KB mode: bank 0 drives the whole pattern table.
      this.load8kVromBank((this.chrBank0 & 0x0f) * 2, 0x0000);
    } else {
      this.load4kVromBank(this.chrBank0 & 0x0f, 0x0000);
      this.load4kVromBank(this.chrBank1 & 0x0f, 0x1000);
    }
  };

  Mappers[10].prototype.updatePrgBanks = function () {
    var romCount = this.nes.rom.romCount;

    if (this.prgMode === 0) {
      // 16 KB at $8000, last 16 KB fixed at $C000.
      this.loadRomBank(this.prgBank0 % romCount, 0x8000);
      this.loadRomBank(romCount - 1, 0xc000);
    } else {
      // Second-to-last 16 KB fixed at $8000, 16 KB at $C000.
      this.loadRomBank(romCount - 2, 0x8000);
      this.loadRomBank(this.prgBank1 % romCount, 0xc000);
    }
  };

  Mappers[10].prototype.clockIrqCounter = function () {
    if (this.irqCounter === 0 || this.irqReload) {
      this.irqCounter = this.irqLatch;
      this.irqReload = false;
    } else {
      this.irqCounter--;
    }

    if (this.irqCounter === 0 && this.irqEnabled) {
      this.nes.cpu.requestIrq(this.nes.cpu.IRQ_NORMAL);
      this.irqEnabled = false;
    }
  };

  Mappers[10].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("MMC4: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.updateChrBanks();
    this.updatePrgBanks();
    this.resetIrqHandler();
  };

  Mappers[10].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.chrBank0 = this.chrBank0;
    s.chrBank1 = this.chrBank1;
    s.prgBank0 = this.prgBank0;
    s.prgBank1 = this.prgBank1;
    s.prgMode = this.prgMode;
    s.chrMode = this.chrMode;
    s.irqLatch = this.irqLatch;
    s.irqCounter = this.irqCounter;
    s.irqReload = this.irqReload;
    s.irqEnabled = this.irqEnabled;
    s.lastA12 = this.lastA12;
    return s;
  };

  Mappers[10].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.chrBank0 = s.chrBank0;
    this.chrBank1 = s.chrBank1;
    this.prgBank0 = s.prgBank0;
    this.prgBank1 = s.prgBank1;
    this.prgMode = s.prgMode;
    this.chrMode = s.chrMode;
    this.irqLatch = s.irqLatch;
    this.irqCounter = s.irqCounter;
    this.irqReload = s.irqReload;
    this.irqEnabled = s.irqEnabled;
    this.lastA12 = s.lastA12;
    // The CPU's copy of the ROM windows and the PPU's copy of the pattern windows
    // are not part of the mapper's state, so re-derive them from the registers.
    // Restoring only the registers would leave the previous game's banks mapped.
    this.updateChrBanks();
    this.updatePrgBanks();
  };
}

module.exports = { register: register };
